const generateAlphanumeric = (length, includeUppercase = true, includeLowercase = true, 
    includeNumbers = true, prefix = '', suffix = '')=> {
// Define character sets
const uppercaseChars = 'ABCDEFGHJKLMNPQRSTUVWXYZ'; // Removed I and O to avoid confusion
const lowercaseChars = 'abcdefghjkmnpqrstuvwxyz';  // Removed l and o to avoid confusion
const numberChars = '23456789';  // Removed 0 and 1 to avoid confusion

// Build the character set based on parameters
let chars = '';
if (includeUppercase) chars += uppercaseChars;
if (includeLowercase) chars += lowercaseChars;
if (includeNumbers) chars += numberChars;

// Default to all character types if none are selected
if (chars === '') {
chars = uppercaseChars + numberChars;
}

// Account for prefix and suffix in the length calculation
const randomPartLength = Math.max(0, length - prefix.length - suffix.length);

// Generate random part of the code
let code = '';
for (let i = 0; i < randomPartLength; i++) {
const randomIndex = Math.floor(Math.random() * chars.length);
code += chars[randomIndex];
}

// Add prefix and suffix
return prefix + code + suffix;
}
export default generateAlphanumeric;